

// import { Form, Formik } from "formik";
// import FormField from "../forms/FormField";
// import * as Yup from "yup";
// import { useEffect, useMemo, useRef, useState } from "react";
// import { toast } from "react-toastify";
// import { TailwindSpinner } from "../Spinner/Spinner";
// import { DownloadModal } from "../DownloadModal";
// import MemberEnrollmentTable from "../MemberEnrolements/MemberEnrolmentTable";
// import { TransactionReportColumn } from "../Table/TableColums";
// import { useGetMemebersTransactionReport } from "../../hooks/Query/useGetAllMembersTransactions";
// import { downloadFile } from "../../utils/downloadFile";
// import { useDownloadTransactionReport } from "../../hooks/Query/useDownloadTransactionReport";

// const validationSchema = Yup.object({
//   fromDate: Yup.date().required("From date is required"),
//   tillDate: Yup.date().required("Till date is required"),
//   limit: Yup.string(),
// });

// const initialValues = {
//   fromDate: "",
//   tillDate: "",
//   limit: "",
// };
// export default function CreateMembersTransactionReport() {
//   const [page, setPage] = useState(1);
//   const [payloadData, setPayloadData] = useState();
//   const [formData, setFormData] = useState(initialValues);
//   const [showDownloadOption, setShowDownloadOption] = useState(false);
//   const [downloadFormat, setDownloadFormat] = useState("");
//   const [shouldDownload, setShouldDownload] = useState(false);
//   const [openModal, setOpenModal] = useState(false);
//   const [transactionReport, setTransactionReport] = useState([]);
//   const [downloadPayload, setDownloadPayload]=useState()
//   const formikRef = useRef();

//   // GET REPORT
//   const {
//     data: report,
//     isFetching: loading,
//     refetch,
//   } = useGetMemebersTransactionReport({
//     payload: payloadData,
//     page: page,
//   });
//   // DOWNLOAD REPORT
//   const { data: downloadData, isLoading, isError } = useDownloadTransactionReport({
//     payload: downloadPayload
//   });
//   // Sync formData with Formik values
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (formikRef.current?.values) {
//         setFormData(formikRef.current.values);
//       }
//     }, 300);
//     return () => clearInterval(interval);
//   }, []);

//   // Show download modal if limit is "All"
//   useEffect(() => {
//     if (formData?.limit === "All") {
//       setOpenModal(true);
//       setShowDownloadOption(false);
//     }
//   }, [formData]);

//   const payload = useMemo(
//     () => `from_date=${formData?.fromDate}&to_date=${formData?.tillDate}`,
//     [formData]
//   );

//   useEffect(() => {
//     if (!loading && report?.data) {
//       const nairaValue = report?.data?.data?.map(
//         (value) => value?.Redeem_points / 2
//       );

//       const newValue = report?.data?.data?.map((item, idx) => ({
//         ...item,
//         Naira_value: nairaValue[idx],
//         Remarks:"VALID"
//       }));

//       setTransactionReport(newValue);
//     }
//   }, [loading, report]);

//   const handleShowDownloadReport = (value) => {
//  if (value?.fromDate === "" || value?.tillDate === "") {
//       return toast.error("Kindly fill all required fields.");
//     } else {
//       setShowDownloadOption(!showDownloadOption);
//     }
//   };

//   const handleDownloadReport = (values, format) => {
//     if (
//       values?.fromDate === "" ||
//       values?.tillDate === "" ||
//       values?.limit === ""
//     ) {
//       toast.error("Kindly fill all required fields");
//       return;
//     }
//     setDownloadPayload(values);
//     setDownloadFormat(format);
//     setShouldDownload(true);
//   };

//   const handlePageChange = (pageNumber) => {
//     setPage(pageNumber);
//     refetch();
//   };

//   console.log('ERROR', isError)

//   // Trigger download automatically when data arrives
//   useEffect(() => {
//    // console.log(shouldDownload);
//       console.log(downloadData?.data?.data);
//     if(isError){
//       toast.error("An error occurred ")
//       return;
//     }
//     if (shouldDownload && downloadData?.data?.data?.length > 0) {
//       downloadFile({
//         data: downloadData?.data?.data,
//         format: downloadFormat,
//         fileName:`FirstRewards Members Transactions Report ${downloadPayload?.fromDate} - ${downloadPayload?.tillDate}`
//       });

//       setShouldDownload(false);
//     } else if (
//       shouldDownload &&
//       !isLoading &&
//       !downloadData?.data?.data?.length
//     ) {
//       toast.warning("No data available to download.");
//       setShouldDownload(false);
//     }
//   }, [downloadData, shouldDownload, downloadFormat, isLoading, downloadPayload, isError]);

//   return (
//     <div className="max-w-7xl mx-auto p-4 md:p-6 bg-white rounded-lg">
//       <div className="mb-6">
//         <h1 className="text-lg font-medium text-gray-900">
//           Members Transaction Report
//         </h1>
//         <p className="text-grey-200 text-sm">
//           View all transaction report in the program.
//         </p>
//       </div>
//       <Formik
//         innerRef={formikRef}
//         initialValues={initialValues}
//         validationSchema={validationSchema}
//         onSubmit={(values) => {
//           setPayloadData(values);
//         }}
//       >
//         {({ values, errors }) => {
//           return (
//             <Form className="md:w-[711px] relative h-auto">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
//                 <FormField
//                   label="From Date"
//                   name="fromDate"
//                   type="date"
//                   required={true}
//                 />
//                 <FormField
//                   label="Till Date"
//                   name="tillDate"
//                   type="date"
//                   required={true}
//                 />

//                 {showDownloadOption && (
//                   <FormField
//                     label="Download Limit"
//                     name="limit"
//                     type="select"
//                     options={[
//                       { value: "100000", label: "100,000" },
//                       { value: "200000", label: "200,000" },
//                       { value: "500000", label: "500,000" },
//                       { value: "1000000", label: "1,000,000" },
//                       { value: "All", label: "All" },
//                     ]}
//                   />
//                 )}
//               </div>

//               <div className="flex flex-col md:flex-row gap-4 mt-6 justify-between items-center">
//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="bg-mysecondary hover:bg-blue-800 text-white px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm "
//                 >
//                   {loading ? <TailwindSpinner /> : "Search"}
//                 </button>
//                 <div>
//                   <button
//                     type="button"
//                     disabled={isLoading}
//                     variant="outline"
//                     className=" text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm "
//                     onClick={() => handleShowDownloadReport(values)}
//                   >
//                     {/* <Download className="mr-2 h-4 w-4" /> */}
//                     {" Download As"}
//                   </button>
//                 </div>
//               </div>
//               {showDownloadOption && (
//                 <div className="flex justify-center  md:justify-end ">
//                   <div className="  right-0 mt-2 text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 rounded flex items-center  justify-end w-[189px]  flex-col">
//                     <button
//                       type="button"
//                       disabled={isLoading}
//                       className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white flex justify-center items-center"
//                       onClick={() => handleDownloadReport(values, "pdf")}
//                     >
//                       {isLoading && downloadFormat === "pdf" ? <TailwindSpinner/> :"Pdf"}
//                     </button>
//                     <button
//                       disabled={isLoading}
//                       type="button"
//                       className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white flex justify-center items-center"
//                       onClick={() => handleDownloadReport(values, "csv")}
//                     >
//                          {isLoading && downloadFormat === "csv" ? <TailwindSpinner/> :"Csv"}
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </Form>
//           );
//         }}
//       </Formik>

//       {report && transactionReport?.length > 0 ? (
//         <MemberEnrollmentTable
//           columns={TransactionReportColumn}
//           data={transactionReport}
//           page={page}
//           setPage={setPage}
//           handlePageChange={handlePageChange}
//           totalPage={report?.data?.pagination?.total}
//           total_pages={report?.data?.pagination?.total_pages}
//           loading={loading}
//           title="Transaction"
//         />
//       ) : report && report?.data?.data?.length === 0 ? (
//         <div className="text-center text-gray-500 mt-10">
//           No data available for the selected criteria.
//         </div>
//       ) : null
      
//       }
//       {openModal && (
//         <DownloadModal
//           setOpenModal={setOpenModal}
//           value={formData}
//           openModal={openModal}
//           payload={payload}
//         />
//       )}
//     </div>
//   );
// }




import { Form, Formik } from "formik";
import FormField from "../forms/FormField";
import * as Yup from "yup";
import { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import { TailwindSpinner } from "../Spinner/Spinner";
import { DownloadModal } from "../DownloadModal";
import MemberEnrollmentTable from "../MemberEnrolements/MemberEnrolmentTable";
import { TransactionReportColumn } from "../Table/TableColums";
import { useGetMemebersTransactionReport } from "../../hooks/Query/useGetAllMembersTransactions";
import { downloadFile } from "../../utils/downloadFile";
import { useDownloadTransactionReport } from "../../hooks/Query/useDownloadTransactionReport";

const validationSchema = Yup.object({
  fromDate: Yup.date().required("From date is required"),
  tillDate: Yup.date().required("Till date is required"),
  limit: Yup.string(),
});

const initialValues = {
  fromDate: "",
  tillDate: "",
  limit: "",
};

export default function CreateMembersTransactionReport() {
  const [page, setPage] = useState(1);
  const [payloadData, setPayloadData] = useState();
  const [formData, setFormData] = useState(initialValues);
  const [showDownloadOption, setShowDownloadOption] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState("");
  const [shouldDownload, setShouldDownload] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [transactionReport, setTransactionReport] = useState([]);
  const [downloadPayload, setDownloadPayload] = useState();
  const [activeDateType, setActiveDateType] = useState(1);
  const formikRef = useRef();

  // GET REPORT
  const {
    data: report,
    isFetching: loading,
    refetch,
  } = useGetMemebersTransactionReport({
    payload: payloadData,
    page: page,
  });

  // DOWNLOAD REPORT
  const { data: downloadData, isLoading, isError } = useDownloadTransactionReport({
    payload: downloadPayload,
  });

  // Sync formData with Formik values
  useEffect(() => {
    const interval = setInterval(() => {
      if (formikRef.current?.values) {
        setFormData(formikRef.current.values);
      }
    }, 300);
    return () => clearInterval(interval);
  }, []);

  // Show download modal if limit is "All"
  useEffect(() => {
    if (formData?.limit === "All") {
      setOpenModal(true);
      setShowDownloadOption(false);
    }
  }, [formData]);

  // Reset form when switching tabs
  const handleTabSwitch = (dateType) => {
    setActiveDateType(dateType);
    setShowDownloadOption(false);
    setTransactionReport([]);
    setPayloadData(undefined);
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
    console.log("Tab switched, form reset, activeDateType:", dateType);
  };

  const payload = useMemo(
    // () => `from_date=${formData?.fromDate}&to_date=${formData?.tillDate}`,
    // [formData]
    () => `from_date=${formData?.fromDate}&to_date=${formData?.tillDate}&date_type=${activeDateType}`,
    [formData, activeDateType]
  );

  useEffect(() => {
    if (!loading && report?.data) {
      const nairaValue = report?.data?.data?.map(
        (value) => value?.Redeem_points / 2
      );
      const newValue = report?.data?.data?.map((item, idx) => ({
        ...item,
        Naira_value: nairaValue[idx],
        Remarks: "VALID",
      }));
      setTransactionReport(newValue);
    }
  }, [loading, report]);

  const handleShowDownloadReport = (value) => {
    if (value?.fromDate === "" || value?.tillDate === "") {
      return toast.error("Kindly fill all required fields.");
    } else {
      setShowDownloadOption(!showDownloadOption);
    }
  };

  const handleDownloadReport = (values, format) => {
    if (values?.fromDate === "" || values?.tillDate === "" || values?.limit === "") {
      toast.error("Kindly fill all required fields");
      return;
    }
    setDownloadPayload({ ...values, date_type: activeDateType });
    setDownloadFormat(format);
    setShouldDownload(true);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    refetch();
  };

  // Trigger download automatically when data arrives
  useEffect(() => {
    if (isError) {
      toast.error("An error occurred ");
      return;
    }
    if (shouldDownload && downloadData?.data?.data?.length > 0) {
      downloadFile({
        data: downloadData?.data?.data,
        format: downloadFormat,
        fileName: `FirstRewards Members Transactions Report ${downloadPayload?.fromDate} - ${downloadPayload?.tillDate}`,
      });
      setShouldDownload(false);
    } else if (shouldDownload && !isLoading && !downloadData?.data?.data?.length) {
      toast.warning("No data available to download.");
      setShouldDownload(false);
    }
  }, [downloadData, shouldDownload, downloadFormat, isLoading, downloadPayload, isError]);

  return (
    <div className="max-w-7xl mx-auto p-4 md:p-6 bg-white rounded-lg">
      <div className="mb-6">
        <h1 className="text-lg font-medium text-gray-900">
          Members Transaction Report
        </h1>
        <p className="text-grey-200 text-sm">
          View all transaction report in the program.
        </p>
      </div>

      {/* ===== DATE TYPE TABS ===== */}
      <div className="flex gap-4 mb-6">
        <div
          onClick={() => handleTabSwitch(1)}
          className={`flex-1 cursor-pointer rounded-lg border-2 p-4 transition-all ${
            activeDateType === 1
              ? "border-blue-900 bg-white shadow-md"
              : "border-gray-200 bg-gray-50 opacity-50"
          }`}
        >
          <h3
            className={`text-sm font-semibold mb-1 ${
              activeDateType === 1 ? "text-blue-900" : "text-gray-400"
            }`}
          >
            Filter by Timestamp
          </h3>
          <p className={`text-xs ${activeDateType === 1 ? "text-gray-600" : "text-gray-400"}`}>
            Search transactions by the time they were recorded
          </p>
        </div>

        <div
          onClick={() => handleTabSwitch(2)}
          className={`flex-1 cursor-pointer rounded-lg border-2 p-4 transition-all ${
            activeDateType === 2
              ? "border-blue-900 bg-white shadow-md"
              : "border-gray-200 bg-gray-50 opacity-50"
          }`}
        >
          <h3
            className={`text-sm font-semibold mb-1 ${
              activeDateType === 2 ? "text-blue-900" : "text-gray-400"
            }`}
          >
            Filter by Transaction Date
          </h3>
          <p className={`text-xs ${activeDateType === 2 ? "text-gray-600" : "text-gray-400"}`}>
            Search transactions by the date the transaction occurred
          </p>
        </div>
      </div>

      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const payload = { ...values, date_type: activeDateType };
          console.log("Payload being sent:", payload); 
          setPayloadData(payload);
          setPayloadData({ ...values, date_type: activeDateType });
        }}
      >
        {({ values, errors }) => {
          return (
            <Form className="md:w-[711px] relative h-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                <FormField
                  label="From Date"
                  name="fromDate"
                  type="date"
                  required={true}
                />
                <FormField
                  label="Till Date"
                  name="tillDate"
                  type="date"
                  required={true}
                />
                {showDownloadOption && (
                  <FormField
                    label="Download Limit"
                    name="limit"
                    type="select"
                    options={[
                      { value: "100000", label: "100,000" },
                      { value: "200000", label: "200,000" },
                      { value: "500000", label: "500,000" },
                      { value: "1000000", label: "1,000,000" },
                      { value: "All", label: "All" },
                    ]}
                  />
                )}
              </div>

              <div className="flex flex-col md:flex-row gap-4 mt-6 justify-between items-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-mysecondary hover:bg-blue-800 text-white px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm"
                >
                  {loading ? <TailwindSpinner /> : "Search"}
                </button>
                <div>
                  <button
                    type="button"
                    disabled={isLoading}
                    variant="outline"
                    className="text-center border-1 border-mysecondary text-blue-900 hover:bg-blue-50 px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm"
                    onClick={() => {
                      handleShowDownloadReport(values);
                      console.log("Payload being downloaded:", payload);
                    }}
                  >
                    {" Download As"}
                  </button>
                </div>
              </div>

              {showDownloadOption && (
                <div className="flex justify-center md:justify-end">
                  <div className="right-0 mt-2 text-center border-1 border-mysecondary text-blue-900 hover:bg-blue-50 rounded flex items-center justify-end w-[189px] flex-col">
                    <button
                      type="button"
                      disabled={isLoading}
                      className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white flex justify-center items-center"
                      onClick={() => handleDownloadReport(values, "pdf")}
                    >
                      {isLoading && downloadFormat === "pdf" ? <TailwindSpinner /> : "Pdf"}
                    </button>
                    <button
                      disabled={isLoading}
                      type="button"
                      className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white flex justify-center items-center"
                      onClick={() => handleDownloadReport(values, "csv")}
                    >
                      {isLoading && downloadFormat === "csv" ? <TailwindSpinner /> : "Csv"}
                    </button>
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>

      {report && transactionReport?.length > 0 ? (
        <MemberEnrollmentTable
          columns={TransactionReportColumn}
          data={transactionReport}
          page={page}
          setPage={setPage}
          handlePageChange={handlePageChange}
          totalPage={report?.data?.pagination?.total}
          total_pages={report?.data?.pagination?.total_pages}
          loading={loading}
          title="Transaction"
        />
      ) : report && report?.data?.data?.length === 0 ? (
        <div className="text-center text-gray-500 mt-10">
          No data available for the selected criteria.
        </div>
      ) : null}

      {openModal && (
        <DownloadModal
          setOpenModal={setOpenModal}
          value={formData}
          openModal={openModal}
          payload={payload}
        />
      )}
    </div>
  );
}